import React, { useState, useEffect } from "react";
import api from "../Services/api";
import './main.css';

const Calculadora = () => {

	// var regex = /[.,\s]/g;
	const [button, setButton] = useState(false);
	const [click, setClick] = useState(false);
	const [block, setBlock] = useState(false);
	const [RendaBruta, setRendaBruta] = useState([{ view: "", value: "" }]);
	const [Contri, setContri] = useState([{ view: "", value: "" }]);
	const [tabelaIr, setTabelaIr] = useState([]);
	const [C3, setC3] = useState();
	const [C4, setC4] = useState();
	const [C5, setC5] = useState();
	const [C6, setC6] = useState();
	const [D4, setD4] = useState();
	const [D5, setD5] = useState();
	const [D6, setD6] = useState();
	const [D7, setD7] = useState();
	const [E4, setE4] = useState();
	const [E5, setE5] = useState();
	const [E6, setE6] = useState();
	const [E7, setE7] = useState();
	const [E15, setE15] = useState();
	const [C12, setC12] = useState();
	const [D14, setD14] = useState();
	const [D15, setD15] = useState();
	const [C13, setC13] = useState();
	const [C15, setC15] = useState();
	const [E13, setE13] = useState();
	const [G14, setG14] = useState();
	const [C14View, setC14View] = useState();
	const [E14, setE14] = useState();

	useEffect(() => {
		api.get("ObterTabelaIR")
			.then(response => {
				setTabelaIr(response.data);
				setC3(response.data[0].FaixaMax);
				setC4(response.data[1].FaixaMax);
				setC5(response.data[2].FaixaMax);
				setC6(response.data[3].FaixaMax);

				setD4(response.data[1].Percentual);
				setD5(response.data[2].Percentual);
				setD6(response.data[3].Percentual);
				setD7(response.data[4].Percentual);

				setE4(response.data[1].Deducao);
				setE5(response.data[2].Deducao);
				setE6(response.data[3].Deducao);
				setE7(response.data[4].Deducao);
			})
			.catch(error => {
				throw new Error(error);
			});
	}, []);

	const calculate = event => {
		if (RendaBruta.value === undefined || Contri.value === undefined || RendaBruta.value === "" || Contri.value === "") return false
		setBlock(true);
		setClick(true);
		setButton(false);
		setE15(0);
		setE13(0);
		setG14(0);
		setC15(0);
		setE14(0);

		//Variavel de calculo
		var G15 = 0;
		var G12 = 0;
		var G13 = 0;
		var C14 = 0;
		var internC15 = 0;
		var internE15 = 0;
		var internE13 = 0;

		var C12 = RendaBruta.value;
		var C13 = Contri.value;

		//C15
		if (C12 > C3) {
			var calc = C12 * 0.12;
			setC15(calc);
			internC15 = calc;

		}
		//C14

		if (C13 > internC15) {
			setC14View(C14);
		}
		else {
			if ((C12 - internC15 <= C3 && C12 - C3 >= 0) || (C12 - internC15 <= C3 && C12 - C3 >= 0)) {
				var calcC14 = C12 - C3;
				calcC14.toFixed(2);
				C14 = calcC14;
				setC14View(calcC14);
			}
			else {
				let calcC14 = internC15 - C13;
				calcC14.toFixed(2);
				C14 = calcC14;
				setC14View(calcC14);
			}
		}
		//G12
		if (C12 <= C3) {
			G12 = 0;
		}
		else {
			if (C12 <= C4) {
				let caclG12 = C12 * D4 - E4;
				G12 = caclG12.toFixed(2);
			}
			else if (C12 <= C5) {
				let caclG12 = C12 * D5 - E5;
				G12 = caclG12.toFixed(2);

			}
			else if (C12 <= C6) {
				let caclG12 = C12 * D6 - E6;
				G12 = caclG12.toFixed(2);
			}
			else {
				let caclG12 = C12 * D7 - E7;
				G12 = caclG12.toFixed(2);
			}
		}
		//G13
		if ((C12 - C13) <= C3) {
			G13 = 0;
		}
		else {
			if ((C12 - C13) <= C4) {
				let calcG13 = (C12 - C13) * D4 - E4;
				G13 = calcG13.toFixed(2);
			}
			else if ((C12 - C13) <= C5) {
				let calcG13 = (C12 - C13) * D5 - E5;
				G13 = calcG13.toFixed(2);
			}
			else if ((C12 - C13) <= C6) {
				let calcG13 = (C12 - C13) * D6 - E6;
				G13 = calcG13.toFixed(2);
			}
			else {
				let calcG13 = (C12 - C13) * D7 - E7;
				G13 = calcG13.toFixed(2);
			}
		}
		//G14
		if ((C12 - C14) <= C3) {
			setG14(0);
		}
		else {
			if ((C12 - C14) <= C4) {
				let calcG14 = (C12 - C13) * D4 - E4;
				setG14(calcG14);
			}
			else if ((C12 - C14) <= C5) {
				let calcG14 = (C12 - C14) * D5 - E5;
				setG14(calcG14);
			}
			else if ((C12 - C14) <= C6) {
				let calcG14 = (C12 - C14) * D6 - E6;
				setG14(calcG14);
			}
			else {
				let calcG14 = (C12 - C14) * D7 - E7;
				setG14(calcG14);
			}
		}
		//G15
		if ((C12 - internC15) <= C3) {
			G15 = 0;
		}
		else {
			if ((C12 - internC15) <= C4) {
				let calcG15 = (C12 - internC15) * D4 - E4;
				G15 = calcG15;
			}
			else if ((C12 - internC15) <= C5) {
				let calcG15 = (C12 - C14) * D5 - E5;
				G15 = calcG15;
			}
			else if ((C12 - internC15) <= C6) {
				let calcG15 = (C12 - internC15) * D6 - E6;
				G15 = calcG15;
			}
			else {
				let calcG15 = (C12 - internC15) * D7 - E7;
				G15 = calcG15;
			}
		}
		//E13
		if (C12 <= C3) {
			setE13("Rendimento anual isento");
		}
		else {
			if ((C13 / C12) > 0.12) {
				internE13 = internE15;
				setE13(internE15);
			}
			else {
				var calcE13 = G12 - G13;
				internE13 = calcE13;
				setE13(calcE13);
			}
		}
		//E15 e E14
		if (C12 >= 0) {
			if (C12 <= C3) {

				setE15("Rendimento anual isento");
				setE14("Rendimento anual isento");

			}
			else {
				var calcE15 = G12 - G15;
				setE15(calcE15);
				var calcE14 = calcE15 - internE13;
				setE14(calcE14);
			}
		}

		if (C12 !== "") {
			setD14("% " + (C14 / C12 * 100).toFixed(2));
			setD15("% " + (internC15 / C12 * 100).toFixed(2));
		}
		else {
			setD14("% 0.00");
			setD15("% 0.00");
		}
	}
	const clear = event => {
		setBlock(false)
		setButton(true)
		setClick(false)
		setRendaBruta({ view: "", value: "" });
		setContri({ view: "", value: "" });
		setE13("");
		setC15("");
		setD14("");
		setD15("");
		setE14("");
		setE15("");
		setC14View("");

		document.getElementById('Contri').value = "";
		document.getElementById('RendaBruta').value = "";
	}
	useState(() => {
		if (button === true) {
			setRendaBruta({ view: "", value: "" });
			setContri({ view: "", value: "" });
			setE13("");
			setC15("");
			setD14("");
			setD15("");
			setE14("");
			setE15("");
			setC14View("");
		}
	})


	const handleChangeRendaBruta = event => {
		const result = event.target.value.replace(/[^0-9,.]/gi, '');
		setRendaBruta({ view: result.replace(",", "."), value: result.replace(",", ".") });
	};
	const formatCurrencyRendaBruta = event => {
		if (RendaBruta.value !== undefined)
			setRendaBruta({ view: Number(RendaBruta.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), value: RendaBruta.value })
	}
	const handleChangeContribuicao = event => {
		const result = event.target.value.replace(/[^0-9,.]/gi, '').toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
		setContri({ view: result.replace(",", "."), value: result.replace(",", ".") });
	}
	const formatCurrencyContri = event => {
		if (Contri.value !== undefined)
			setContri({ view: Number(Contri.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), value: Contri.value })
	}
	const formatCurrencyGeneral = (value) => {
		if (value === "") {
			return "";
		}
		if ((value !== undefined && value !== "") || (value === 0)) {
			return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
		}
	}

	return (
		<div className="">
			<div id="myTabContent">
				<div className="tab-pane   show active" id="home" role="tabpanel" aria-labelledby="home-tab">

					<div className="row register-form">
						<div className="col-md-12" id="inputs" style={{ minWidth: "100%", position: "relative" }}>
							<div style={{ width: "100%", overflow: "hidden" }}>
								<div className="col-md-6" style={{ float: "left", width: "400px" }}>
									<label className="mb-2">Renda bruta anual tributável*</label>

									<div style={{ paddingBlock: "1px" }}>
										<input id="RendaBruta" style={{ border: "1px solid #ccc" }} className="form-control pula" type="text" value={RendaBruta.view} onChange={handleChangeRendaBruta} onBlur={formatCurrencyRendaBruta} placeholder="Renda bruta anual tributável" disabled={block} />
									</div>

								</div>

								<div className="col-md-6" style={{ float: "left", width: "400px" }}>
									<label className="mb-2">Contribuição**</label>
									<div style={{ paddingBlock: "1px" }}>
										<input id="Contri" style={{ border: "1px solid #ccc" }} className="form-control pula" type="text" value={Contri.view} onChange={handleChangeContribuicao} onBlur={formatCurrencyContri} placeholder="Contribuições para previdência complementar" disabled={block} />

									</div>
								</div>

								<div className="col-md-6 calc1">
									<br />
									<div className="calc2">
										<input onClick={click === false ? () => calculate() : () => clear()} type="submit" value={click === false ? "Calcular" : "Limpar"} id="botaoEnviar" className="btn" style={{ backgroundColor: "#d6740d", color: "#fff", position: 'relative', minWidth: "120px", height: "44px" }} />
									</div>
								</div>
							</div>
						</div>


						<div className="col-md-12">
							<hr />
							<div className="form-group">
								<div className="col-md-12">
									<label style={{ position: 'relative', bottom: '-70%' }}>Benefício Fiscal***</label>
									<input type="text" id="E13" className="form-control negrito" placeholder="" value={E13 !== "Rendimento anual isento" ? formatCurrencyGeneral(E13) : E13} disabled />
								</div>
							</div>

						</div>
						<div className="col-md-12">&nbsp;</div>
						<div className="col-md-12">
							<label htmlFor="C14" className="col-md-12">Sugestão de Aporte</label>
							<div className="form-group">
								<div className="col-md-4">
									<input type="text" id="C14" className="form-control negrito  " placeholder="" value={formatCurrencyGeneral(C14View)} disabled />
								</div>
								<div className="col-md-2">
									<input type="text" id="D14" className="form-control negrito  " placeholder="-" value={D14} disabled />
								</div>
								<div className="col-md-6">
									<input type="text" id="E14" className="form-control negrito" placeholder="" value={E14 !== "Rendimento anual isento" ? formatCurrencyGeneral(E14) : E14} disabled />
								</div>
							</div>
						</div>
						<div className="col-md-12">&nbsp;</div>
						<div className="col-md-12">
							<label htmlFor="C14" className="col-md-12">Dedução Máxima</label>
							<div className="form-group">
								<div className="col-md-4">
									<input type="text" id="C15" className="form-control negrito" placeholder="" value={formatCurrencyGeneral(C15)} disabled />
								</div>
								<div className="col-md-2">
									<input type="text" id="D15" className="form-control negrito " placeholder="-" value={D15} disabled />
								</div>
								<div className="col-md-6">
									<input type="text" id="E15" className="form-control negrito" placeholder="" value={E15 !== "Rendimento anual isento" ? formatCurrencyGeneral(E15) : E15} disabled />
								</div>
							</div>
						</div>
						<div className="col-md-12">&nbsp;</div>


						<div className="col-md-12 desc">
							<p>(*) Rendimento bruto (total) recebido
								no ano corrente que incide o imposto de
								renda da pessoa física, como por
								exemplo: remuneração, aluguel, pensão e
								outros.</p>
							<p>(**) Contribuições e aportes
								realizados na Forluz no ano corrente.
								Obs.: Caso tenha plano PGBL e/ou
								previdência complementar em outra
								entidade, favor acrescentar os valores.</p>
							<p>(***) Valor pago a menos de IR no ano
								seguinte.</p>
						</div>
					</div>
				</div>
			</div>

		</div>
	)
};
export default Calculadora